import { RawHeader } from "./Header";
import { HeaderTab } from "./Navigation/Navigation";
import { HeaderPanels, HeaderPanelWrapper } from "./Panels/Panels";
export var Header = Object.assign(RawHeader, {
    Tab: HeaderTab,
    PanelWrapper: HeaderPanelWrapper,
    Panels: HeaderPanels,
});
